import { useCallback, useEffect, useState } from 'react';

/** Keep one tutorial active and stop playback when cookie preferences change. */
const useVideoPlayback = () => {
  const [activeVideoId, setActiveVideoId] = useState(null);
  const onClose = useCallback(() => setActiveVideoId(null), []);

  useEffect(() => {
    // Playback never changes the visitor's analytics or marketing preferences.
    // Stop external content when the visitor revisits and changes their cookie preferences.
    window.addEventListener('cc:onChange', onClose);
    return () => window.removeEventListener('cc:onChange', onClose);
  }, [onClose]);

  return { activeVideoId, onPlay: setActiveVideoId, onClose };
};

export default useVideoPlayback;
